let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2ZNTa")).then(() => parcelRequire('8P1aa'));